var _defs, _style, _use, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90 90",
    width: 90,
    height: 90,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 50,
    height: 50,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyAQMAAAAk8RryAAAAAXNSR0IB2cksfwAAAANQTFRF////p8QbyAAAAA5JREFUeJxjYBgFgwkAAAGQAAHTuxD+AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "grd1",
    gradientUnits: "userSpaceOnUse",
    x1: 248.082,
    y1: 246.993,
    x2: 173.836,
    y2: 321.239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2671bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#112d8d"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "grd2",
    gradientUnits: "userSpaceOnUse",
    cx: 45.787,
    cy: 67.683,
    r: 64.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#131f48"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "grd3",
    gradientUnits: "userSpaceOnUse",
    x1: 125.082,
    y1: 50.993,
    x2: 50.836,
    y2: 125.239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2671bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#112d8d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "grd4",
    gradientUnits: "userSpaceOnUse",
    x1: 125.082,
    y1: 50.993,
    x2: 50.836,
    y2: 125.239
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2671bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#112d8d"
  })))), _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan {\n\t\t\twhite-space: pre\n\t\t}\n\n\t\t.Facebookshp0 {\n\t\t\tfill: url(#grd1)\n\t\t}\n\n\t\t.Facebookshp1 {\n\t\t\topacity: 0.8;\n\t\t\tmix-blend-mode: multiply;\n\t\t\tdisplay: none;\n\t\t\tfill: url(#grd2)\n\t\t}\n\n\t\t.Facebookshp2 {\n\t\t\tfill: url(#grd3)\n\t\t}\n\n\t\t.Facebookshp3 {\n\t\t\tfill: url(#grd4)\n\t\t}\n\n\t\t.Facebookshp4 {\n\t\t\tfill: #ffffff\n\t\t}\n\t")), _use || (_use = /*#__PURE__*/React.createElement("use", {
    href: "#img1",
    x: 20,
    y: 20
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "FacebookFacebookshp0",
    d: "M124.15 262.09L124.15 220.26C124.15 207.63 134.48 197.31 147.1 197.31L188.93 197.31C201.55 197.31 211.88 207.63 211.88 220.26L211.88 262.09C211.88 274.71 201.55 285.04 188.93 285.04L174.87 285.04L167.51 283.24L161.16 285.04L147.1 285.04C134.48 285.04 124.15 274.71 124.15 262.09Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Facebookshp1",
    d: "M110.29 67.68C110.29 103.3 81.41 132.18 45.79 132.18C10.16 132.18 -18.71 103.3 -18.71 67.68C-18.71 32.06 10.16 3.18 45.79 3.18C81.41 3.18 110.29 32.06 110.29 67.68Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Facebookshp2",
    d: "M1.15 66.09L1.15 24.26C1.15 11.63 11.48 1.31 24.1 1.31L65.93 1.31C78.55 1.31 88.88 11.63 88.88 24.26L88.88 66.09C88.88 78.71 78.55 89.04 65.93 89.04L51.87 89.04L44.51 87.24L38.16 89.04L24.1 89.04C11.48 89.04 1.15 78.71 1.15 66.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "Facebookshp3",
    d: "M1.15 66.09L1.15 24.26C1.15 11.63 11.48 1.31 24.1 1.31L65.93 1.31C78.55 1.31 88.88 11.63 88.88 24.26L88.88 66.09C88.88 78.71 78.55 89.04 65.93 89.04L51.87 89.04L44.51 87.24L38.16 89.04L24.1 89.04C11.48 89.04 1.15 78.71 1.15 66.09Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "Facebookshp4",
    d: "M51.87 59.29L51.87 89.04L38.16 89.04L38.16 59.29L27.02 59.29L27.02 46.61L38.16 46.61L38.16 36.95C38.16 25.96 44.71 19.88 54.73 19.88C57.93 19.88 61.2 20.17 64.55 20.74L64.55 31.53L59.02 31.53C53.57 31.53 51.87 34.92 51.87 38.39L51.87 46.61L64.03 46.61L62.09 59.29L51.87 59.29Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.1bd408739406fe72f5eedc6d07fee4eb.svg";
export { ForwardRef as ReactComponent };